<template>
    <console-content class="pa-4">
        <v-row class="ma-n2">
            <v-col class="pa-2" cols="12">
                <sales-dashboard-table ref="daily" :mode="NSHOP_STATISTICS_MODES.DAILY.value" @success="searchRest" />
            </v-col>
            <v-col class="pa-2" cols="12">
                <sales-dashboard-table ref="weekly" :mode="NSHOP_STATISTICS_MODES.WEEKLY.value" :idle-text="IDLE_TEXT" />
            </v-col>
            <v-col class="pa-2" cols="12">
                <sales-dashboard-table ref="monthly" :mode="NSHOP_STATISTICS_MODES.MONTHLY.value" :idle-text="IDLE_TEXT" />
            </v-col>
        </v-row>
    </console-content>
</template>
<script>
import ConsoleContent from "@/templates/console/ConsoleContent.vue";
import SalesDashboardTable from "@/components/console/integrated-viewer/sales-dashboard-table.vue";
import { NSHOP_STATISTICS_MODES } from "@/store/nshop";

// 통합 주문 통계 — 통합뷰어(integrated-viewer)와 root·admin 이 본다.
export default {
    components: {
        ConsoleContent,
        SalesDashboardTable,
    },
    data() {
        return {
            NSHOP_STATISTICS_MODES,
            IDLE_TEXT: "일간 매출을 불러오면 함께 조회합니다. 날짜를 고르면 바로 조회합니다",

            // 주간·월간 첫 조회를 이미 불렀는지
            restSearched: false,
        };
    },
    mounted() {
        // 일간을 먼저 부르고, 일간이 처음 성공한 순간(searchRest) 주간·월간을 부른다.
        // 셋을 한꺼번에 부르면 403(예: 허용 IP 밖)·5xx 때 같은 alert 가 3번 뜬다.
        // 일간이 실패한 동안은 나머지를 부르지 않는다 — 그 묶음의 날짜를 바꾸면 그 묶음만 조회한다.
        // 첫 요청의 결과를 기다리지 않는 것은, 그 사이 일간 날짜를 바꿔 나중 요청이 성공해도 주간·월간을 부르기 위해서다.
        this.$refs.daily.search();
    },
    methods: {
        searchRest() {
            if (this.restSearched) return;
            this.restSearched = true;
            // 사용자가 날짜를 바꿔 이미 조회한 묶음은 다시 부르지 않는다. 화면을 나간 뒤면 ref 가 없다.
            [this.$refs.weekly, this.$refs.monthly].forEach((table) => {
                if (table && !table.searched) table.search();
            });
        },
    },
};
</script>
